import { FooterContainer, PrivacyBox } from './style';
import { APP_NAME } from '@constants/app';

function Footer({ isMobile }) {
  return (
    <FooterContainer isMobile={isMobile} marginTop={false}>
      <PrivacyBox isMobile={isMobile}>{APP_NAME}</PrivacyBox>
    </FooterContainer>
  );
}

export default Footer;
